"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveLowResultSchema = exports.ActiveLowEntrySchema = void 0;
const zod_1 = require("zod");
exports.ActiveLowEntrySchema = zod_1.z.object({
    signalName: zod_1.z.string(),
    activeLow: zod_1.z.boolean(),
});
exports.ActiveLowResultSchema = zod_1.z.object({
    activeLowEntries: zod_1.z.array(exports.ActiveLowEntrySchema),
});
//# sourceMappingURL=active-low-denormalized.js.map